import * as Yup from 'yup';

export const amlCIFormValidationSchema = Yup.object().shape({
  subscription: Yup.string().required(),
  resourceGroup: Yup.string().required(),
  amlWorkspace: Yup.string().required(),
  computeSize: Yup.string().required(),
  computeType: Yup.string().required(),
});
